import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { scrubQueryClient } from "@/lib/search/clientPiiScrub";
interface Props {
  query: string;
}
export function NoResultsForQuery(t0) {
  const $ = _c(10);
  const {
    query
  } = t0;
  let t1;
  if ($[0] !== query) {
    t1 = scrubQueryClient(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safe = t1;
  let t2;
  if ($[2] !== safe) {
    t2 = <AlertTitle className="line-clamp-none text-base font-semibold">No results for '{safe}'</AlertTitle>;
    $[2] = safe;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>Can't find what you're looking for? Request a product.</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `/product-requests?q=${encodeURIComponent(safe)}`;
  let t5;
  if ($[5] !== t4) {
    t5 = <AlertDescription className="justify-items-center">{t3}<Button asChild={true}><Link href={t4}>Request a product</Link></Button></AlertDescription>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <Alert className="border-0 bg-transparent">{t2}{t5}</Alert>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}